(function () {
  'use strict';

  var SMM = {
    overlay: null,
    activeItem: null,

    init: function () {
      var items = document.querySelectorAll('.navigation__item--with-smm');
      if (!items.length) return;

      if (!this.overlay) {
        this.overlay = document.createElement('div');
        this.overlay.className = 'smm-overlay';
        document.body.appendChild(this.overlay);
        var self = this;
        this.overlay.addEventListener('click', function () {
          self.closeAll();
        });
      }

      var self = this;
      items.forEach(function (item) {
        if (item.dataset.smmInit) return;
        item.dataset.smmInit = '1';
        self.initItem(item);
      });
    },

    initItem: function (item) {
      var panel = item.querySelector('.smm-panel');
      if (!panel) return;

      var self = this;
      var openTimer, closeTimer;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          self.open(item);
        }, 150);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          self.close(item);
        }, 200);
      });

      panel.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });

      panel.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          self.close(item);
        }, 200);
      });

      panel.querySelectorAll('.smm-sidebar__item').forEach(function (si) {
        si.addEventListener('mouseenter', function () {
          self.activateGrid(panel, si.getAttribute('data-smm-target'));
        });
      });

      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && self.activeItem) {
          self.closeAll();
        }
      });
    },

    open: function (item) {
      if (this.activeItem && this.activeItem !== item) {
        this.close(this.activeItem);
      }
      item.classList.add('smm-open');
      var panel = item.querySelector('.smm-panel');
      if (panel) panel.setAttribute('aria-hidden', 'false');
      var link = item.querySelector(':scope > .navigation__link');
      if (link) link.setAttribute('aria-expanded', 'true');
      if (this.overlay) this.overlay.classList.add('smm-overlay--visible');
      this.activeItem = item;
    },

    close: function (item) {
      item.classList.remove('smm-open');
      var panel = item.querySelector('.smm-panel');
      if (panel) panel.setAttribute('aria-hidden', 'true');
      var link = item.querySelector(':scope > .navigation__link');
      if (link) link.setAttribute('aria-expanded', 'false');
      if (this.activeItem === item) {
        if (this.overlay) this.overlay.classList.remove('smm-overlay--visible');
        this.activeItem = null;
      }
    },

    closeAll: function () {
      var self = this;
      document.querySelectorAll('.navigation__item--with-smm.smm-open').forEach(function (item) {
        self.close(item);
      });
    },

    activateGrid: function (panel, index) {
      panel.querySelectorAll('.smm-sidebar__item').forEach(function (si) {
        si.classList.toggle('smm-sidebar__item--active', si.getAttribute('data-smm-target') === index);
      });
      panel.querySelectorAll('.smm-grid').forEach(function (grid) {
        grid.classList.toggle('smm-grid--active', grid.getAttribute('data-smm-grid') === index);
      });
    }
  };

  function doInit() {
    SMM.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doInit);
  } else {
    doInit();
  }

  document.addEventListener('shopify:section:load', doInit);
  document.addEventListener('shopify:block:select', doInit);
})();
